import userApis from "apis/users";
import { DEMO_STAY_LISTINGS } from "data/listings";
import { setLoading } from "features/auth";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const OrdersList = () => {
  const jwt = useSelector((state) => state?.auth?.jwt);
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        dispatch(setLoading(true));
        const api = new userApis(jwt);
        const response = await api.getAdminOrders();
        setOrders(response);
        dispatch(setLoading(false));
      } catch (err) {
        toast.error("Failed to fetch orders. Please try again later.");
      } finally {
        dispatch(setLoading(false));
      }
    };

    fetchOrders();
  }, [jwt]);
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Orders List</h1>
      {orders.length === 0 ? (
        <p>No orders found.</p>
      ) : (
        <table className="min-w-full border-collapse border border-gray-200">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-gray-300 px-4 py-2">ID</th>
              <th className="border border-gray-300 px-4 py-2">Date</th>
              <th className="border border-gray-300 px-4 py-2">Slot</th>
              <th className="border border-gray-300 px-4 py-2">Place ID</th>
              <th className="border border-gray-300 px-4 py-2">Price</th>
              <th className="border border-gray-300 px-4 py-2">User Name</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order.id} className="hover:bg-gray-50">
                <td className="border border-gray-300 px-4 py-2">{order.id}</td>
                <td className="border border-gray-300 px-4 py-2">
                  {new Date(order.date).toLocaleDateString()}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {DEMO_STAY_LISTINGS?.find((obj) => obj.id == order.placeId)
                    ?.slots?.[order.slot]?.name || order.slot}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {order.placeId}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {order.price}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {order.userName}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default OrdersList;
